export const DETACHED_INIT = 'DETACHED_INIT';
export const DETACHED_REMOVE = 'DETACHED_REMOVE';
